import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=3feb6a56&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=js&"
export * from "./RoleTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=3feb6a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb6a56",
  null
  
)

export default component.exports